<template>
  <div>
    <BaseModal
      :model-value="showContact"
      @close="closeContacts"
      :title="$t(`contact_artist.title`)"
    >
      <div class="sm-p-5 p-2 sm:w-lg w-full relative">
        <div
          v-if="copied"
          class="absolute top-0 left-1/2 transform -translate-x-1/2 border flex items-center justify-center rounded-lg p-2 bg-primary text-white"
        >
          <span class="text-sm">{{ $t("common.copied") }} </span>
        </div>
        <div
          class="rounded-sm animate-in fade-in slide-in-from-top-4 duration-300"
        >
          <div class="space-y-4">
            <div
              v-if="artwork.userId.phone_number"
              class="flex items-center justify-between gap-3"
            >
              <div class="flex items-center gap-3">
                <Icon name="heroicons:phone" size="20" />
                <NuxtLink :to="`tel:${artwork.userId.phone_number}`">
                  {{ artwork.userId.phone_number }}
                </NuxtLink>
              </div>
              <button
                v-if="isSupported"
                type="button"
                @click="copy(artwork.userId.phone_number)"
                class="cursor-pointer"
              >
                <Icon name="heroicons:document-duplicate" size="20" />
              </button>
            </div>

            <div
              v-if="artwork.userId.social_links"
              class="flex flex-col space-y-4"
            >
              <template
                v-for="(val, key) in artwork.userId.social_links"
                :key="key"
              >
                <div
                  v-if="val"
                  class="flex items-center space-x-2"
                  :title="String(key).toUpperCase()"
                >
                  <div class="shrink-0">
                    <Icon :name="(socialIcons as any)[key]" size="20" />
                  </div>

                  <div
                    class="flex items-center justify-between w-full space-x-2"
                  >
                    <span class="capitalize">{{
                      $t(`profile.edit.${key}`)
                    }}</span>
                    <div class="flex items-center space-x-3">
                      <button
                        v-if="isSupported"
                        type="button"
                        @click="copy(val)"
                        class="cursor-pointer"
                      >
                        <Icon name="heroicons:document-duplicate" size="20" />
                      </button>
                      <NuxtLink
                        :to="val"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Icon
                          name="heroicons:arrow-top-right-on-square"
                          size="20"
                          class="text-primary hover:text-primary-blue"
                        />
                      </NuxtLink>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseCircleButton
      class="w-full"
      variant="gray"
      rounded="rounded-lg"
      @click="openContacts"
      :title="$t('contact_artist.button')"
    >
      <Icon name="heroicons:envelope" size="16" />
    </BaseCircleButton>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { socialIcons } from "~/constants/social-icons";
import { useClipboard } from "@vueuse/core";

const { copy, copied, isSupported } = useClipboard();

defineProps<{ artwork: any }>();
const showContact = ref(false);

const openContacts = (): void => {
  showContact.value = true;
  document.body.style.overflow = "hidden";
};
const closeContacts = (): void => {
  document.body.style.overflow = "auto";
  showContact.value = false;
};
</script>
